const QUANTITY_QUERY_PARAM = "quantity"
const KIT_QUERY_PARAM = "kit"
const IPAD_QUERY_PARAM = "iPad"
const SIMPLE_CARE_QUERY_PARAM = "simpleCare"
const PLAN_QUERY_PARAM = "plan"

// Default values
let quantity = 1
let selectedKit = "event"
let iPadSelected = true
let simpleCareSelected = true
let selectedPlan = "plus"

// Override default values from URL search params
let searchParams = new URLSearchParams(window.location.search)
if (searchParams.get(QUANTITY_QUERY_PARAM)) {
    quantity = searchParams.get(QUANTITY_QUERY_PARAM)
}
if (searchParams.get(KIT_QUERY_PARAM)) {
    selectedKit = searchParams.get(KIT_QUERY_PARAM)
}
if (searchParams.get(IPAD_QUERY_PARAM)) {
    iPadSelected = searchParams.get(IPAD_QUERY_PARAM) === "true"
}
if (searchParams.get(SIMPLE_CARE_QUERY_PARAM)) {
    simpleCareSelected = searchParams.get(SIMPLE_CARE_QUERY_PARAM) === "true"
}
if (searchParams.get(PLAN_QUERY_PARAM)) {
    selectedPlan = searchParams.get(PLAN_QUERY_PARAM)
    if (selectedPlan === "null") {
        selectedPlan = null
    }
}

// Products to be loaded
let kitVariants = null
let simpleCareProduct = null
let softwarePlans = null

const ajaxGetOptions = {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
}

function fetchHaloKits(completion) {
    fetch('/products/halo-kits-september-2019.js', ajaxGetOptions)
        .then(response => response.json())
        .then(data => {
            const haloKits = {
                eventKit: findVariantBySku(data, "HALO_1.01_B_EK_10.9"),
                installKit: findVariantBySku(data, "HALO_1.01_B_IK_10.9")
            }
            completion(haloKits)
        });
}

function fetchAnnualSoftware(completion) {
    fetch('/products/new-plans-test-annual-halo-license.js', ajaxGetOptions)
        .then(response => response.json())
        .then(product => {
            const softwarePlans = {
                lite: findVariantBySku(product, "halo_lite_yearly_1"),
                core: findVariantBySku(product, "halo_core_yearly_1"),
                plus: findVariantBySku(product, "halo_plus_yearly_1"),
                pro: findVariantBySku(product, "halo_pro_yearly_1"),
                select: findVariantBySku(product, "halo_select_yearly_1")
            }
            completion(softwarePlans)
        });
}

function fetchSimpleCare(completion) {
    fetch('/products/halo-2019-smpl-care.js', ajaxGetOptions)
        .then(response => response.json())
        .then(product => {
            const protectionPlan = findVariantBySku(product, "SIMPLE-CARE-09-2024")
            completion(protectionPlan)
        });
}

function fetchiPad(completion) {
    fetch('/products/include-11-inch-ipad-air-m4.js', ajaxGetOptions)
        .then(response => response.json())
        .then(product => {
            const iPad = findVariantBySku(product, "iPad_Air_11_M4_SG_128GB")
            completion(iPad)
        });
}

function loadProducts(completion) {
    let successCount = 0
    let numberOfRequests = 4

    fetchHaloKits((haloKits) => {
        kitVariants = haloKits
        successCount++
        if (successCount === numberOfRequests) completion()
    })
    fetchAnnualSoftware((swPlans) => {
        softwarePlans = swPlans
        successCount++
        if (successCount === numberOfRequests) completion()
    })
    fetchSimpleCare((protectionPlan) => {
        simpleCareProduct = protectionPlan
        successCount++
        if (successCount === numberOfRequests) completion()
    })
    fetchiPad((iPad) => {
        iPadVariant = iPad
        successCount++
        if (successCount === numberOfRequests) completion()
    })
}

function loadAccessories(completion) {
    fetch('/products/8-x-8-green-screen-kit.js', ajaxGetOptions)
        .then(response => response.json())
        .then(data => {
            completion([data])
        });
}

function selectHaloKit(kits, kitType = "event") {
    switch (kitType) {
        case "event":
            return kits.eventKit
        case "install":
            return kits.installKit
    }
}

function findVariantBySku(product, sku) {
    return product.variants.filter(v => v.sku === sku)[0]
}

function formatPrice(shopifyPrice, decimals = false) {
    let priceInDollars = shopifyPrice / 100
    let priceWithCommas = priceInDollars.toLocaleString('en-US', { maximumFractionDigits: decimals ? 2 : 0 })
    return "$" + priceWithCommas
}

function getBundleTotal() {
    let bundlePrice = 0

    kitItem = selectHaloKit(kitVariants, selectedKit)
    bundlePrice += kitItem.price

    if (simpleCareSelected) {
        bundlePrice += simpleCareProduct.price
    }

    if (iPadSelected) {
        bundlePrice += iPadVariant.price
    }

    if (selectedPlan) {
        bundlePrice += softwarePlans[selectedPlan].price
    }

    return bundlePrice * quantity
}

function loadCurrentUser(completion) {
    let options = {...ajaxGetOptions}
    options.credentials = "include"

    fetch('https://www.simplebooth.com/user', {
        method: 'GET',
        credentials: "include",
        origin: "https://buy.simplebooth.com"
    })
        .then(response => response.json())
        .then(data => {
            console.log(data)
            completion([data])
        });
}
